/**
 * This class is used to create a focus trap for a given element.
 * We use this focus-trap library because it supports shadow DOM.
 * https://github.com/focus-trap/focus-trap
 *
 * We use the tabbableOptions to get the shadow root of the element.
 * This is necessary because the focus trap needs to know about the shadow root
 * to properly trap the focus.
 */

import { createFocusTrap, FocusTrap } from 'focus-trap';

export class FocusTrapHelper {
  private focusTrap: FocusTrap;

  constructor(hostElement: HTMLElement) {
    this.focusTrap = createFocusTrap(hostElement, {
      clickOutsideDeactivates: true,
      tabbableOptions: {
        getShadowRoot: true,
      },
    });
  }

  public activateFocusTrap() {
    this.focusTrap.activate();
  }

  public deactivateFocusTrap() {
    this.focusTrap.deactivate();
  }
}
